import { Box } from "@mui/material";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import ReplaceIcon from "../../../AppIcons/AppIconsReplace";
import { useTableLayoutClasses } from "../TableLayout.style";

type TReplaceIconComponent = {
    item: any;
}

const ReplaceIconComponent = (props: TReplaceIconComponent) => {

    const classes = useTableLayoutClasses();
    const { t } = useTranslation();

    const repCode = props.item.replacementCode || props.item.replacedCode;
    const tooltip = props.item.replacementCode ? "common.spareparts.part.withreplacement": "common.spareparts.part_detail.replacing";

    return (
        <Box sx={classes.columnReplaced}>
            {/* 
              * Se ha il campo withreplacement: mostra il campo replacementCode.
              * Se invece il campo withreplacement non esiste, ma è presente il campo replacementCode, lo mostra 
            */}
            {(props.item?.withreplacement
                || (props.item.withreplacement === undefined && repCode)) &&

                <ReplaceIcon
                    title={`${t(tooltip)} ${repCode}`}
                />
            }
        </Box>
    )
}

export default ReplaceIconComponent;